import { jsxs as d, jsx as l } from "react/jsx-runtime";
import { useRef as x, useState as N, useMemo as m, useEffect as R } from "react";
import S from "../../hooks/useOnClickOutside.js";
import j from "./extras/ErrorMessage.js";
import { useFormAutoComplete as _ } from "./extras/FormAutoCompleteProvider.js";
import { b as w } from "../../index.esm-BLYQOf9m.js";
import '../../assets/style6.css';/* empty css                   */
function G({
  label: r,
  errorMsg: n,
  containerProps: f,
  value: u,
  onChangeOption: s,
  options: t,
  autoCompleteKey: b,
  ...h
}) {
  const o = x(null), [i, c] = N(u ?? t[0]?.value), [E, a] = N(!1), v = m(
    () => typeof n == "string" && (n != null || /^[\s]*$/.test(n)),
    [n]
  ), y = m(() => r != null || /^[\s]*$/.test(r), [r]), $ = m(() => {
    const e = t.find((I) => I.value === i);
    return e == null ? "" : e.name;
  }, [i, t]), p = x(!0);
  R(() => {
    if (p.current) {
      u == null && t.length > 0 && s != null && (s(t[0].value), c(t[0].value)), p.current = !1;
      return;
    }
    c(u);
  }, [u]);
  function k(e) {
    return () => {
      c(e), s?.(e), a(!1);
    };
  }
  function F() {
    a((e) => !e);
  }
  return S(o, () => a(!1)), _(b, (e) => {
    c(e), s?.(e);
  }), /* @__PURE__ */ d(
    "div",
    {
      ...f,
      className: "input-field" + (v ? " error" : "") + ` ${f?.className ?? ""}`,
      children: [
        y ? /* @__PURE__ */ l("label", { className: "input-field-label", children: r }) : null,
        /* @__PURE__ */ d("div", { className: "select-input-container", ref: o, children: [
          /* @__PURE__ */ d(
            "button",
            {
              type: "button",
              className: "select-input-btn",
              "aria-expanded": E,
              onClick: F,
              ...h,
              children: [
                /* @__PURE__ */ l("span", { children: $ }),
                /* @__PURE__ */ l(w, {})
              ]
            }
          ),
          /* @__PURE__ */ l("ul", { className: "select-option-list", role: "listbox", children: t.map((e) => /* @__PURE__ */ l(
            "li",
            {
              className: "select-option-list__item",
              role: "option",
              "aria-selected": e.value === i,
              children: /* @__PURE__ */ l("button", { type: "button", onClick: k(e.value), children: e.name })
            },
            `${e.value}`
          )) })
        ] }),
        /* @__PURE__ */ l(j, { children: n })
      ]
    }
  );
}
export {
  G as default
};
